export default __webpack_public_path__ + "static/media/logo.add622d3.png";